const hideModal = (selector) => global.$(selector).modal('hide');

export default hideModal;
